export const ROLES = {
    ADMIN: 'Admin',
    MANAGER: 'Manager',
    BILLING_STAFF: 'Billing Staff',
    SERVICE_STAFF: 'Service Staff',
    INVENTORY_STAFF: 'Inventory Staff',
}